import React from 'react';
import NotificationCardView from '../view/NotificationCardView';
import EditIcon from '@material-ui/icons/Subject';
import { useHistory } from 'react-router-dom';
import useTranslations from '../../../hooks/useTranslations';

const NotificationCardEngine = ({
  notificationData,
  onClickedEdit,
  onToggleChange,
  onDisabledToggleClicked,
  key,
  hideToggle = false
}) => {
  const history = useHistory();
  const t = useTranslations();

  const actionButtons = [
    {
      onAction: () => {
        onClickedEdit(notificationData.id);
      },
      icon: EditIcon,
      tooltip: t('email_template.title'),
      internalName: 'edit' // for data-testid
    }
  ];

  return (
    <NotificationCardView
      id={notificationData.id}
      key={key}
      title={notificationData.title}
      description={notificationData.description}
      disableToggle={!notificationData.canBeDisabled}
      hideToggle={hideToggle}
      isActive={notificationData.enabled !== false}
      actionButtons={actionButtons}
      onToggleChange={() => {
        onToggleChange(notificationData.id);
      }}
      onDisabledToggleClicked={onDisabledToggleClicked}
    />
  );
};

export default NotificationCardEngine;
